import { Component, inject, OnInit } from '@angular/core';
import { TokenExpirationService } from '../../core/services/token-expiration.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatCard, MatCardContent, MatCardFooter } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/divider';
import { PairingFormComponent } from './pairing-form/pairing-form.component';
import { CreateUserFormComponent } from './create-user-form/create-user-form.component';

@Component({
  selector: 'app-pairing',
  templateUrl: './pairing.component.html',
  styleUrls: [
    './pairing.component.scss',
    '../login-form/login-form.component.scss',
  ],
  imports: [
    MatCard,
    MatCardContent,
    MatTooltip,
    MatDivider,
    PairingFormComponent,
    CreateUserFormComponent,
    MatCardFooter,
    TranslateModule,
  ],
})
export class PairingComponent implements OnInit {
  shouldCreateUser = false;
  createText: string;
  connectText: string;

  private route = inject(ActivatedRoute);
  private tokenExpirationService = inject(TokenExpirationService);
  private translateService = inject(TranslateService);

  ngOnInit() {
    this.tokenExpirationService.startExpirationTimer(
      this.route.snapshot.queryParams['start'],
    );
    this.createText = this.translateService
      .instant('pairing.create.text', { actabl: 'Actabl' })
      .split('#');
    this.connectText = this.translateService
      .instant('pairing.connect.text')
      .split('#');
  }

  toggleFormType() {
    this.shouldCreateUser = !this.shouldCreateUser;
  }
}
